<script lang="ts">
    import Manager from "../application/models/Manager.ts";
    import Filter from "../application/models/Filter.ts";
    import {_} from 'svelte-i18n';
    import SmallCard from "../presentationals/SmallCard.svelte";
    import CardPack from "../presentationals/CardPack.svelte";

    export let manager: Manager;
    export let filter: Filter;

    let weekDays = ["mon", "tue", "wed", "thu", "fri", "sat"];
    let formatedOccasions = [];
    $:{
        formatedOccasions = [];
        for (let i = 0; i < 6; i++) {
            let occasionArray = manager.occasionManager.getOccasionsTimeSorted($filter, i + 1);
            let sortedArray = [];
            for (let i = 0; i < 56; i++) {
                sortedArray[i] = [];
            }
            occasionArray.forEach(occasion => {
                sortedArray[occasion.startBlock - 28].push(occasion);
            });
            formatedOccasions.push(sortedArray);
        }
    }
</script>

<div class="is-hidden-tablet">
    {#each weekDays as day,i}
        <div class="has-text-centered">
            <div class="title">
                <strong>{$_('weekDays.' + day)}</strong>
            </div>
            {#each formatedOccasions[i] as occasions}
                {#if occasions.length === 1}
                    <SmallCard on:modalOpen cardData={occasions[0]} manager={manager}/>
                {/if}
                {#if occasions.length > 1}
                    <CardPack on:modalOpen cards={occasions} manager={manager} onMobile={true}/>
                {/if}
            {/each}
        </div>
    {/each}
</div>